import { connect, ConnectedProps } from "react-redux";
import { withRouter } from "react-router";
import { IStoreState } from "../../reducers/types";
import {
  fetchFlights,
  fetchHotels,
  fetchCars,
  listWatches,
  setTripsFilter,
  fetchHomes,
  listPaymentMethods,
  setTripSearchQuery,
  fetchPackages,
  fetchExperiences,
  populateTripQueryParams,
  setSelectedFlight,
  setSelectedHotel,
  setSelectedCar,
  setSelectedHome,
  setSelectedPackage,
  setSelectedPackageFlight,
  setSelectedPackageHotel,
  setSelectedExperience,
  fetchActivitiesXsell,
} from "./actions/actions";
import { fetchFlightDisruptions } from "../DisruptionProtection/actions/actions";
import { TripsList } from "./component";
import {
  getSelectedCar,
  getSelectedFlight,
  getSelectedHotel,
  getTripsFilter,
  getAreTripsLoading,
  hasFetchTripsError,
  hasTripsToDisplay,
  getOpenModal,
  activeCfarCountSelector,
  getTripsCounts,
  getSelectedHome,
  getSelectedPackageHotel,
  getSelectedPackageFlight,
  getFetchFlightsCallState,
  getSelectedExperience,
  getSelectedPackage,
  getNextUpcomingTrip,
  getAirportMap,
  getActivitiesXsellExperiences,
  getActivitiesXsellCallState,
} from "./reducer";
import { getRewardsAccountWithLargestValue } from "../../modules/rewards/reducer";
import {
  myTripsPartialFlightsListDpExerciseFactsPropertiesSelector,
  myTripsPartialEligibilityDpExerciseFactsPropertiesSelector,
  getFetchFlightDisruptionsCallState,
  getDpAttachedFlightItineraryIds,
} from "../DisruptionProtection/reducer";
import { fetchRedeemedEarnOffers } from "../../modules/travel-wallet/actions/actions";
import { fetchRewardsAccounts } from "../../modules/rewards/actions/actions";

const mapStateToProps = (state: IStoreState) => ({
  tripsFilter: getTripsFilter(state),
  selectedFlight: getSelectedFlight(state),
  selectedHotel: getSelectedHotel(state),
  selectedCar: getSelectedCar(state),
  selectedHome: getSelectedHome(state),
  selectedPackage: getSelectedPackage(state),
  selectedPackageHotel: getSelectedPackageHotel(state),
  selectedPackageFlight: getSelectedPackageFlight(state),
  selectedExperience: getSelectedExperience(state),
  areTripsLoading: getAreTripsLoading(state),
  flightsCallState: getFetchFlightsCallState(state),
  hasError: hasFetchTripsError(state),
  hasTripsToDisplay: hasTripsToDisplay(state),
  activeCfarCount: activeCfarCountSelector(state),
  openModal: getOpenModal(state),
  partialFlightsListDpExerciseFactsProperties:
    myTripsPartialFlightsListDpExerciseFactsPropertiesSelector(state),
  partialEligibilityDpExerciseFactsProperties:
    myTripsPartialEligibilityDpExerciseFactsPropertiesSelector(state),
  fetchFlightDisruptionsCallState: getFetchFlightDisruptionsCallState(state),
  tripsCounts: getTripsCounts(state),
  dpAttachedFlightItineraryIds: getDpAttachedFlightItineraryIds(state),
  nextUpcomingTrip: getNextUpcomingTrip(state),
  airportMap: getAirportMap(state),
  activitiesXsellExperiences: getActivitiesXsellExperiences(state),
  activitiesXsellCallState: getActivitiesXsellCallState(state),
  activitiesXsellRewardsAccount: getRewardsAccountWithLargestValue(state),
});

const mapDispatchToProps = {
  fetchCars,
  fetchFlights,
  fetchHotels,
  listWatches,
  setTripsFilter,
  fetchFlightDisruptions,
  fetchHomes,
  listPaymentMethods,
  setTripSearchQuery,
  fetchPackages,
  fetchExperiences,
  fetchRedeemedEarnOffers,
  fetchRewardsAccounts,
  populateTripQueryParams,
  setSelectedFlight,
  setSelectedHotel,
  setSelectedCar,
  setSelectedHome,
  setSelectedPackage,
  setSelectedPackageFlight,
  setSelectedPackageHotel,
  setSelectedExperience,
  fetchActivitiesXsell,
};

const connector = connect(mapStateToProps, mapDispatchToProps);

export type TripsListConnectorProps = ConnectedProps<typeof connector>;

export const ConnectedTripsList = connector(withRouter(TripsList));
